import storage from '@utils/storage'

window._tmr = window._tmr || []

const debug = storage.getItem('da.donation.debug.tmr')

let tmrGlobalLabel

export default {
  install: Vue => {
    Vue.tmr = {
      setGlobalLabel(label) {
        tmrGlobalLabel = label
      },
      send(type = 'event', {
        category = undefined,
        action = undefined,
        label = undefined,
      } = {}) {
        const payload = {
          id: window._tmr_da_tracker_id,
          type,
          category,
          action,
          label: label ?? tmrGlobalLabel,
        }

        if (window._tmr) {
          window._tmr.push({
            event: payload,
          })
        }

        if (debug) {
          console.log('[TMR EVENT]', payload)
        }
      },
      event(data) {
        this.send('sendEvent', data)
      },
      goal(goal, params) {
        const payload = {
          id: window._tmr_da_tracker_id,
          type: 'reachGoal',
          goal,
          params: {
            ...params,
            newPage: true,
          },
          label: tmrGlobalLabel,
        }

        if (window._tmr) {
          window._tmr.push(payload)
        }

        if (debug) {
          console.log('[TMR GOAL]', payload)
        }
      },
      pageView() {
        const payload = {
          id: window._tmr_da_tracker_id,
          type: 'pageView',
          start: (new Date()).getTime(),
        }

        window._tmr.push(payload)
      }
    }
    Vue.prototype.$tmr = Vue.tmr
  },
}
